'use client';
import { useEffect, useLayoutEffect, useState, useRef } from 'react';
import { MainProductCard } from './MainProductCard';
import { ToggleProductCard } from './ToggleProductCard';

export default function UpsellToggle({ block, position }) {
  const { title, label, main_product, toggle_product, _metadata } =
    block.upsell_toggle;
  const [selectedCard, setSelectedCard] = useState('main');
  const upsellRef = useRef();

  // Can be true or false and tells us whether the toggle is actually a downsell
  const toggleIsUpsell = toggle_product?.upsell_product;

  // If on mobile, scroll down to upsell component (if ?toggle=true)
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const toggle = queryParams.get('toggle');
    if (window.innerWidth <= 1024 && toggle === 'true' && upsellRef.current) {
      window.scrollTo({
        top: upsellRef.current.offsetTop - 100,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, [position, _metadata.uid]);

  function handleClick(card) {
    setSelectedCard(card);
  }

  // Reset selection to support history change
  useLayoutEffect(() => {
    return () => {
      setSelectedCard('main');
    };
  }, []);

  const toggleCardData = {
    blockData: toggle_product,
    toggleIsUpsell: toggleIsUpsell,
    selectedCard: selectedCard,
    handleClick: handleClick
  };

  const mainCardData = {
    blockData: main_product,
    toggleIsUpsell: toggleIsUpsell,
    selectedCard: selectedCard,
    handleClick: handleClick
  };

  // Order the products based on whether the toggle is an upsell or downsell
  const productsInOrder = toggleIsUpsell
    ? [main_product, toggle_product]
    : [toggle_product, main_product];
  const productCards = toggleIsUpsell
    ? [
        <MainProductCard data={mainCardData} key="main" />,
        <ToggleProductCard data={toggleCardData} key="toggle" />
      ]
    : [
        <ToggleProductCard data={toggleCardData} key="toggle" />,
        <MainProductCard data={mainCardData} key="main" />
      ];

  return (
    <section
      id={`${_metadata.uid}_${position}`}
      data-name="upsell-toggle"
      className={`upsell-toggle bg-parlor-green-95 not-last:lg:mb-8`}
      ref={upsellRef}
    >
      {title && <div className="sh10 pb-4 text-white">{title}</div>}
      {label && <div className="sh12 pb-2 text-white">{label}</div>}

      <div className="relative grid grid-cols-2 gap-x-3 text-black">
        {productsInOrder.map((product, idx) => (
          <div className="flex" key={idx}>
            {product?.tag_text && (
              <span className="sh13 bg-light-green self-stretch px-3 py-[2px]">
                {product.tag_text}
              </span>
            )}
          </div>
        ))}
      </div>

      <div
        className="relative grid grid-cols-2 gap-x-3"
        data-optimizely="bundle-upsell-toggle-flags"
      >
        {productCards}
      </div>
    </section>
  );
}
